import styled, { css } from 'styled-components'

import { Button } from '@Components/Button'
import { up } from '@Globals/Style/breakpoints'
import { absoluteCenter, transition } from '@Globals/Style/mixins'

export const PersonalizationItemRoot = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 55px;
  align-items: center;
  position: relative;

  &:last-of-type {
    margin-bottom: 40px;
  }
`

export const PersonalizationImageContainer = styled.div(({
  theme,
}) => css`
  display: flex;
  justify-content: center;
  position: relative;
  margin-bottom: 21px;
  min-width: 100%;
  overflow: hidden;
  border-radius: ${theme.borderRadius};

  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: ${theme.colors.productGreyOverlay};
    z-index: 1;
  }
`)

export const PersonalizationImage = styled.div`
  display: block;
  min-width: 130px;
  width: 100%;
  max-width: 200px;
  max-height: 200px;
`

export const PersonalizationButton = styled(Button)`
  border-width: 2px;

  &:hover {
    background: #f5f5f5;
  }

  span {
    font-size: 13px;
    font-weight: inherit;
  }

  ${transition}
`

export const PersonalizationCaption = styled.span<{ center?: boolean }>(({
  center,
}) => css`
  display: flex;
  justify-content: center;
  text-align: ${center ? 'center' : 'left'};
  margin: 0 auto 21px;
  max-width: 380px;
  padding-left: 8px;
  padding-right: 8px;
  font-size: 12px;
  color: #777777;
`)

export const PersonalizationSelectItemRoot = styled(PersonalizationItemRoot)`
  min-width: 130px;
  width: calc(50% - 8px);
  margin-bottom: 0;

  &:last-of-type {
    margin-bottom: 0;
  }

  div {
    pointer-events: none;
  }

`

export const PersonalizationSelectImageContainer = styled(PersonalizationImageContainer)(({
  theme,
}) => css`
  z-index: 100;

  &:after {
    bottom: 30px;
    border-radius: ${theme.borderRadius};
    overflow: hidden;
  }
`)

export const PersonalizationSelectImage = styled(PersonalizationImage)<{ selected?: boolean }>(({
  selected,
  theme,
}) => css`
  position: relative;
  margin-bottom: 30px;
  border-radius: ${theme.borderRadius};
  overflow: hidden;

  svg {
    display: none;
    ${selected && `
      display:block;
      position: absolute;
      bottom: 0;
      left: 0;
      padding: 14px;
      width: 46px;
      height: 44px;
      background: ${theme.colors.greyLighterer};
      border-top-right-radius: ${theme.borderRadius};
      z-index: 11;
    `}
  }
`)

export const PersonalizationSelectionButton = styled(PersonalizationButton)(({ theme }) => css`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  margin-bottom: -12px;
  border-style: none;
  pointer-events: all;
  cursor: pointer;
  padding: 0 0 6px;
  background: none;
  min-width: 130px;


  &:hover {
    background: ${theme.colors.greyLightest};
  }

  &:active {
    transform: unset;
  }

  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  > span {
    margin-bottom: 9px;
  }

  span {
    display: flex;
    flex-direction: column;
    position: relative;
    font-weight: 500;
    font-size: 12px;
  }

  ${transition}
`)

export const PersonalizationItemList = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 32px;
`

export const PersonalizationTitle = styled.p<{ noSubtitle?: boolean }>(({ noSubtitle }) => css`
  padding-bottom: 0;
  margin-bottom: ${noSubtitle ? '40px' : '14px'};
  text-align: center;
  font-size: 15px;
  letter-spacing: 0.5px;
  font-weight: 600;
  text-transform: uppercase;

  ${up('phablet')} {
    font-size: 18px;
  }
`)

export const PersonalizationButtonSpan = styled.span<{ capitalize?: boolean }>(({ capitalize }) => css`
  text-transform: ${capitalize ? 'capitalize' : 'inherit'};
  flex: 1 1 100%;
  width: 100%;
  color: #777777;
`)

export const PersonalizationSubTitle = styled.p<{ left?: boolean, marginless?: boolean }>(({
  left,
  marginless,
}) => css`
  text-align: ${left ? 'left' : 'center'};
  margin-bottom: 21px;
  font-weight: 600;
  padding-bottom: 0;
  font-size: 14px;
  padding-top: 17px;
  text-transform: uppercase;
  ${marginless && `
      padding-top: 0;
      margin-bottom: 0;
  `}
`)

export const PersonalizationInfoList = styled.ul`
  list-style: disc;
  max-width: 362px;
  margin: 35px auto 20px;

  li {
    list-style: disc;
    font-size: 12px;
    margin-bottom: 8px;
    margin-left: 22px;
    max-width: 418px;
    color: #777777;
    letter-spacing: 0.2px;
  }
`

export const PersonalizationArea = styled.div(() => css`
  display: flex;
  width: 100%;
  height: 350px;
  overflow: hidden;
  flex-direction: column;
  pointer-events: none;
  position: relative;
  margin-top: 24px;

`)

export const PersonalizationImageWatch = styled.img`
  width: 280px;
  z-index: 100;
  ${absoluteCenter}
`

export const PersonalizationUploadWrap = styled.div`
  display: block;
  max-width: 100%;
  height: 350px;
  max-height: 350px;
  pointer-events: auto;

  .cropper-view-box,
  .cropper-face {
    pointer-events: auto;
  }

  .cropper-modal, .cropper-bg {
    background: ${({ theme }) => theme.colors.greyLighter};
  }
`

export const PersonalizationInformation = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 16px 0;
  width: 100%;
  background: white;

  ${up('tablet')} {
    max-width: 320px;
    background: transparent;
    padding-top: 24px;
  }
`
